export default function CompanyHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/51d1c141d5bcb2aacf413768ece64589.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-white/60"></div>
      </div>
      
      <div className="relative z-10 max-w-[1400px] mx-auto px-8 text-center">
        <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
          会社概要
        </h1>
        <p className="text-xl md:text-2xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
          AI分析×30年の経験で<br />
          EC事業の自動化と成長を支援します
        </p>
      </div>
    </section>
  );
}
